import { merge } from 'lodash'
import shuffler from '../utils/shuffler'

export const Services = {
  app: {
    env: process.env.APPLICATION_ENVIRONMENT || 'Local',
    version: '',
    cookie_domain: process.env.COOKIE_DOMAIN || 'localhost',
  },

  graphql_api: {
    uri: process.env.GRAPHQL_API_URI,
  },

  // Sign-in through the SSO orchestrator (`src/auth/sso`). Only `client_id`
  // reaches the browser (`/api/client-services`). `frontend_url` is the
  // origin the console is served at; unset, each request's own origin.
  sso: {
    authority: process.env.FRONTEND_AUTH_AUTHORITY,
    client_id: process.env.FRONTEND_AUTH_CLIENT_ID,
    frontend_url: process.env.FRONTEND_URL,
  },

  // Server only: the Mapped STS — the org exchange and refresh as the
  // console's user client, and the console's own service token.
  token_exchange: {
    uri: process.env.MAPPED_TOKEN_EXCHANGE_URI,
    client_id: process.env.MAPPED_TOKEN_EXCHANGE_CLIENT_ID,
    client_secret: process.env.MAPPED_TOKEN_EXCHANGE_CLIENT_SECRET,
    service_client_id: process.env.MAPPED_SERVICE_TOKEN_EXCHANGE_CLIENT_ID,
    service_client_secret:
      process.env.MAPPED_SERVICE_TOKEN_EXCHANGE_CLIENT_SECRET,
  },

  zendesk: {
    shared_secret: process.env.ZENDESK_SSO_SHARED_SECRET,
  },

  grpc_services: {
    orgs: process.env.ORGS_GRPC_SERVICE_ENDPOINT,
    billing: process.env.BILLING_GRPC_SERVICE_ENDPOINT,
    business: process.env.BUSINESS_GRPC_SERVICE_ENDPOINT,
    connectors: process.env.CONNECTORS_GRPC_SERVICE_ENDPOINT,
    merge: process.env.MERGE_GRPC_SERVICE_ENDPOINT,
    ontology: process.env.ONTOLOGY_GRPC_SERVICE_ENDPOINT,
    mappedgpt: process.env.MAPPEDGPT_GRPC_SERVICE_ENDPOINT,
  },

  mapbox: {
    token: process.env.MAPBOX_TOKEN,
  },

  sandbox: {
    // Sandbox v2 (the Fusion Demo org, mapped/rivet-ai docs/LEDGER.md L222): the Sandbox button and
    // /api/join-sandbox-org seat people here since 2026-10-31. People already in the first sandbox
    // (prod ORGUmvDdxfFU7UBvJ8Msx2A6J, dev ORGFEdBM93rarcXPD3hjMHxnD) reach v2 through Switch orgs.
    org_id:
      process.env.APPLICATION_ENVIRONMENT === 'Prod'
        ? 'ORG3BEMGh6ySr8KWAgLAnju7K'
        : 'ORG9J2B7L7cTAVYR75KXL4NJT',

    token: process.env.SANDBOX_TOKEN,
  },

  connectors: {
    client_uri: process.env.CONNECTORS_CLIENT_URI,
  },

  stripe: {
    publishable_key: process.env.STRIPE_PUBLISHABLE_KEY,
  },

  devportal: {
    url: process.env.DEVPORTAL_URL,
    auth_redirect_url: process.env.DEVPORTAL_AUTH_REDIRECT_URL,
  },

  anaxi: {
    url: process.env.ANAXI_URL,
    auth_redirect_url: process.env.ANAXI_AUTH_REDIRECT_URL,
  },

  expertcenter: {
    url: process.env.EXPERTCENTER_URL,
    auth_redirect_url: process.env.EXPERTCENTER_AUTH_REDIRECT_URL,
  },

  grid: {
    pointsChunkSize: process.env.POINTS_CHUNK_SIZE || 100000,
    pointsConcurrencyLimit: process.env.POINTS_CONCURRENCY_LIMIT || 1,
    pointsPageSize: Number(process.env.POINTS_PAGE_SIZE) || 1000,
    pointsPaginationLimit: process.env.POINTS_PAGINATION_LIMIT || 10000,
  },

  metrics: {
    uri: process.env.CONNECTOR_METRICS_API_URI,
    dashboardBarChart:
      process.env.DASHBOARD_BAR_CHART_METRICS_REFETCH_INTERVAL || 30000,
    dashboardSparkline:
      process.env.DASHBOARD_SPARKLINE_METRICS_REFETCH_INTERVAL || 10000,
  },
}

export async function loadClientServices(): Promise<boolean> {
  if (!process.browser) {
    return true
  }

  const res = await fetch('/api/client-services')
  const clientServices = JSON.parse(shuffler(await res.text(), true))

  merge(Services, clientServices)

  return true
}
